module.exports = __webpack_public_path__ + "static/media/in-the-classroom.160fba4e.md";